import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchUserGames } from '../../api/games';
import { useAtom } from 'jotai';
import { currentUserAtom } from '../../auth/AuthAtoms';
import { toast } from 'react-toastify';
import LoadingSpinner from '../../components/LoadingSpinner';

const ViewGamesPage = () => {
    const [currentUser] = useAtom(currentUserAtom);
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const [hideCompleted, setHideCompleted] = useState(true);

    useEffect(() => {
        const fetchGames = async () => {
            setLoading(true);
            setError(null);
            try {
                const gamesData = await fetchUserGames(currentUser.userID);
                setGames(gamesData);
            } catch (error) {
                setError('Error fetching games: ' + error.message);
                toast.error('Error fetching games: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        if (currentUser) {
            fetchGames();
        }

        if (location.state?.message) {
            toast.success(location.state.message);
        }
    }, [currentUser, location.state]);

    const toggleHideCompleted = () => {
        setHideCompleted(!hideCompleted);
    };

    const filteredGames = hideCompleted ? games.filter(game => !game.isFinal) : games;

    return (
        <div className="view-games-page">
            <div className="header-info">
                <h2>My Games</h2>
                {currentUser?.isAdmin && <Link to="/game/create" className="button">Create a New Game</Link>}
            </div>
            <div>
            </div>
            <div>
                <label>
                    <input type="checkbox" checked={hideCompleted} onChange={toggleHideCompleted} />
                    Hide Completed Games
                </label>
            </div>
            {error && <p className="error">{error}</p>}
            {loading ? (
                <LoadingSpinner />
            ) : (
                <div className="view-games-list">
                  <div className="table-scroll-wrapper">
                    <table className="table-striped">
                        <thead>
                            <tr>
                                <th>Home</th>
                                <th>Visiting</th>
                                <th className="col-date">Date</th>
                                <th className="col-campaign">Campaign</th>
                                <th className="col-tournament">Tournament</th>
                                <th className="col-playoff">Playoff</th>
                                <th className="col-final">Final</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredGames.map(game => (
                                <tr key={game.gameID}>
                                    <td>
                                        {game.GameParticipants.find(p => p.role === 'home')?.UserTeam?.name || 'N/A'}
                                    </td>
                                    <td>
                                        {game.GameParticipants.find(p => p.role === 'away')?.UserTeam?.name || 'N/A'}
                                    </td>
                                    <td className="col-date">{new Date(game.created).toLocaleDateString()}</td>
                                    <td className="col-campaign">{game.userCampaignContestID ? 'Yes' : ''}</td>
                                    <td className="col-tournament">{game.TournamentEntry?.Tournament?.name ? 'Daily' : ''}</td>
                                    <td className="col-playoff">{game.playoffRunID ? 'Yes' : ''}</td>
                                    <td className="col-final">{game.isFinal ? 'Yes' : 'No'}</td>
                                    <td>
                                        {game.isFinal ? (
                                            <Link to={`/game/${game.gameID}/summary`} className="button view-button">View</Link>
                                        ) : (
                                            <Link to={`/game/${game.gameID}/play`} className="button">Play</Link>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                  </div>
                </div>
            )}
        </div>
    );
};

export default ViewGamesPage;
